// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channel-sidebar {
  width: var(--sidebar-width);
  background-color: var(--bg-secondary);
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  z-index: 10;
  box-shadow: var(--shadow-md);
  border-right: 1px solid var(--glass-border);
}

.channel-sidebar::after {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--glass-bg);
  backdrop-filter: var(--glass-blur);
  z-index: -1;
}

.channel-header {
  height: var(--header-height);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--glass-border);
  cursor: pointer;
  position: relative;
  transition: all 0.25s ease;
}

.channel-header.has-banner {
  height: 95px;
  align-items: flex-end;
  padding: 12px 16px;
  overflow: visible;
  position: relative;
}

.server-name {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.01em;
}

.header-banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  border-radius: inherit;
}

.header-banner-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  filter: brightness(0.45) saturate(0.85);
  transition: transform 0.4s ease, filter 0.4s ease;
}

.channel-header:hover .header-banner-bg img {
  transform: scale(1.04);
  filter: brightness(0.55) saturate(1);
}

.header-banner-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(10, 12, 16, 0.3) 0%,
    rgba(10, 12, 16, 0.7) 60%,
    var(--bg-secondary, #0c0e14) 100%
  );
  z-index: 1;
}

.header-content {
  position: relative;
  z-index: 2;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.has-banner .header-content {
  background: rgba(12, 14, 20, 0.72);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  padding: 6px 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  text-shadow: none;
}


.channel-list {
  flex: 1;
  overflow-y: auto;
  padding: 20px 0;
  scrollbar-width: none;
}

.channel-category {
  position: relative;
  margin-bottom: 20px;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;
}

.channel-category.is-dragging {
  opacity: 0.35;
  transform: scale(0.98);
  filter: grayscale(0.6);
}

.category-drop-indicator {
  position: absolute;
  left: 12px;
  right: 12px;
  height: 4px;
  z-index: 50;
  display: flex;
  align-items: center;
  pointer-events: none;
}

.category-drop-indicator.top {
  top: -4px;
}

.category-drop-indicator.bottom {
  bottom: -4px;
}

.indicator-pill {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #5865f2;
  box-shadow: 0 0 10px #5865f2, 0 0 4px #fff;
  margin-left: -4px;
  flex-shrink: 0;
}

.indicator-line {
  flex: 1;
  height: 2px;
  background: linear-gradient(90deg, #5865f2, #38bdf8);
  box-shadow: 0 0 8px rgba(88, 101, 242, 0.8);
  border-radius: 2px;
}

.category-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  margin: 0 12px;
  cursor: pointer;
  color: var(--text-muted);
  user-select: none;
}

.category-header.is-draggable {
  cursor: grab;
}

.category-header.is-draggable:active {
  cursor: grabbing;
}

.category-drag-handle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  opacity: 0;
  transform: translateX(-4px);
  transition: opacity 0.2s ease, transform 0.2s ease, color 0.2s ease;
  margin-right: -2px;
  cursor: grab;
}

.category-header:hover .category-drag-handle {
  opacity: 0.8;
  transform: translateX(0);
}

.category-drag-handle:hover {
  opacity: 1 !important;
  color: var(--text-primary);
}

.category-name {
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 1.5px;
  text-transform: uppercase;
}

.channel-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 18px;
  margin: 2px 14px;
  border-radius: 12px;
  cursor: pointer;
  transition: all var(--transition-normal);
  color: var(--text-secondary);
}

.channel-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.channel-name {
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.channel-footer {
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: var(--bg-tertiary);
  border-top: 1px solid var(--glass-border);
  flex-shrink: 0;
}

.voice-connection-card {
  background: rgba(15, 23, 42, 0.75);
  backdrop-filter: blur(16px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.voice-connection-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.voice-status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
}

.voice-status-indicator .dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 8px #22c55e;
  flex-shrink: 0;
}

.voice-status-info {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
}

.voice-status-text {
  font-size: 11px;
  font-weight: 700;
  color: #22c55e;
  white-space: nowrap;
}

.voice-channel-pill {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90px;
}

.voice-heading-actions {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
}

.voice-action-icon {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08) !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  color: #cbd5e1 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
  padding: 0;
}

.voice-action-icon:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  color: #ffffff !important;
  transform: scale(1.05);
}

.disconnect-pill.danger {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: rgba(239, 68, 68, 0.18) !important;
  border: 1px solid rgba(239, 68, 68, 0.35) !important;
  color: #f87171 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
  flex-shrink: 0;
  padding: 0;
}

.disconnect-pill.danger:hover {
  background: #ef4444 !important;
  color: #ffffff !important;
  box-shadow: 0 0 10px rgba(239, 68, 68, 0.5);
  transform: scale(1.05);
}

.voice-connection-controls {
  display: flex;
  flex-direction: row;
  gap: 4px;
  margin-top: 2px;
}

.control-pill {
  flex: 1;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.15s;
  padding: 0;
}

.control-pill:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #f8fafc;
}

.control-pill.active {
  background: rgba(239, 68, 68, 0.22);
  color: #f87171;
  border-color: rgba(239, 68, 68, 0.45);
}

.control-pill.krus-pill.active-krus {
  background: linear-gradient(135deg, rgba(88, 101, 242, 0.35), rgba(139, 92, 246, 0.35));
  color: #c7d2fe;
  border-color: rgba(99, 102, 241, 0.6);
  box-shadow: 0 0 10px rgba(99, 102, 241, 0.4);
}

.control-pill.krus-pill:hover {
  background: linear-gradient(135deg, rgba(88, 101, 242, 0.45), rgba(139, 92, 246, 0.45));
  color: #ffffff;
}

.voice-connection-actions {
  display: flex;
  flex-direction: row; /* Yan yana */
  gap: 4px;
  margin-top: 4px;
}

.voice-connection-actions button {
  flex: 1;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-tertiary);
  border: 1px solid var(--glass-border);
  border-radius: 4px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.voice-connection-actions button:hover {
  background: var(--bg-modifier-hover);
  color: var(--text-primary);
}

.voice-connection-actions button.active {
  background: var(--brand-primary);
  color: white;
  border-color: var(--brand-primary);
}

.disconnect-pill.danger {
  width: 36px;
  height: 36px;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.disconnect-pill.danger:hover {
  background: #ef4444;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.user-panel {
  height: 64px;
  background-color: var(--bg-secondary);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-radius: 20px;
  border: 1px solid var(--glass-border);
  box-shadow: var(--shadow-lg);
}

.user-info {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.user-avatar {
  position: relative;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}

.avatar-inner {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: var(--gradient-brand);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  color: white;
}

.user-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding-left: 10px;
}

.user-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-control-pill {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: transparent !important;
  color: #94a3b8;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
}

.user-control-pill:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  color: #f8fafc;
  transform: translateY(-1px);
}

.username {
  font-size: 14px;
  font-weight: 800;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-tag {
  font-size: 11px;
  font-weight: 700;
  color: var(--text-muted);
  opacity: 0.5;
}

.dm-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;
  scrollbar-width: none;
}

.dm-list::-webkit-scrollbar {
  display: none;
}

.dm-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: var(--radius-md);
  margin-bottom: 4px;
  font-weight: 700;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all var(--transition-normal);
  border: 1px solid transparent;
}

.dm-item.active, .dm-item:hover {
  background-color: var(--bg-modifier-selected);
  color: var(--text-primary);
  border-color: var(--glass-border);
}

.dm-avatar {
  position: relative;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}

.dm-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
  border: 1.5px solid var(--glass-border);
}

.dm-avatar .avatar-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: var(--gradient-brand);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 14px;
  border: 1.5px solid var(--glass-border);
}

.dm-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
  text-align: left;
}

.dm-name {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.dm-status {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  opacity: 0.6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
}

.dm-item.active .dm-status {
  color: var(--brand-light);
  opacity: 0.9;
}

.dm-item .status-dot {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  border-radius: 4px;
  border: 2px solid var(--bg-secondary);
}

.dm-item .status-dot.online { background-color: var(--status-online); }
.dm-item .status-dot.idle { background-color: var(--status-idle); }
.dm-item .status-dot.dnd { background-color: var(--status-dnd); }
.dm-item .status-dot.offline { background-color: var(--status-offline); }

.dm-category {
  font-size: 11px;
  font-weight: 900;
  color: var(--text-muted);
  padding: 20px 16px 8px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  opacity: 0.6;
}

.dm-empty {
  font-size: 13px;
  color: var(--text-muted);
  padding: 24px 16px;
  text-align: center;
}

/* User status indicator in the bottom user panel */
.user-avatar .status-indicator {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 14px;
  height: 14px;
  border-radius: 4px;
  border: 3px solid var(--bg-tertiary);
  box-shadow: var(--shadow-sm);
  z-index: 5;
}

.user-avatar .status-indicator.online { background-color: var(--status-online); }
.user-avatar .status-indicator.idle { background-color: var(--status-idle); }
.user-avatar .status-indicator.dnd { background-color: var(--status-dnd); }
.user-avatar .status-indicator.offline { background-color: var(--status-offline); }

.dm-search {
  padding: 16px;
  margin-bottom: 8px;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 14px;
  color: var(--text-muted);
  pointer-events: none;
}

.search-input-wrapper input {
  width: 100%;
  height: 38px;
  background-color: var(--bg-tertiary);
  border: 1px solid var(--glass-border);
  border-radius: 8px;
  padding: 0 12px 0 40px;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 600;
  outline: none;
  transition: all var(--transition-fast);
}

.search-input-wrapper input:focus {
  border-color: var(--brand-primary);
  background-color: var(--bg-primary);
  box-shadow: 0 0 0 4px rgba(153, 27, 27, 0.1);
}

.search-input-wrapper input::placeholder {
  color: var(--text-muted);
  opacity: 0.6;
}

.server-name-container {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
}

.owner-crown-icon {
  color: #fbbf24; /* Discord Gold */
  flex-shrink: 0;
}

.category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  margin: 0 4px;
}

.category-clickable {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  flex: 1;
}

.category-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.category-action-btn {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  padding: 0;
  opacity: 0;
}

.category-header:hover .category-action-btn {
  opacity: 1;
}

.category-action-btn:hover {
  color: var(--text-primary);
  background: var(--bg-modifier-hover);
}

.category-action-btn.danger:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.15);
}

.empty-category-notice {
  padding: 8px 16px;
  font-size: 12px;
  color: var(--text-muted);
  font-style: italic;
}

.empty-category-notice span {
  font-weight: bold;
  color: var(--brand-primary);
}

/* Channel Type Selector in Modal */
.channel-type-selector {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.channel-type-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 8px;
  background-color: #2b2d31;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.channel-type-option:hover {
  background-color: #35373c;
}

.channel-type-option.active {
  background-color: rgba(153, 27, 27, 0.2);
  border-color: var(--brand-primary);
}

.channel-type-option .type-icon {
  color: var(--text-muted);
  flex-shrink: 0;
}

.channel-type-option.active .type-icon {
  color: var(--brand-primary);
}

.channel-type-option .type-info {
  display: flex;
  flex-direction: column;
}

.channel-type-option .type-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
}

.channel-type-option .type-desc {
  font-size: 12px;
  color: var(--text-muted);
}

/* Server Dropdown */
.server-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 10px;
  right: 10px;
  background-color: #111214;
  border-radius: 10px;
  padding: 8px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.75), 0 0 0 1px rgba(255, 255, 255, 0.08);
  z-index: 9999;
  border: 1px solid var(--glass-border);
}

.dropdown-overlay {
  position: fixed;
  inset: 0;
  z-index: 90;
}

.dropdown-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 4px;
  background: transparent;
  border: none;
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.dropdown-item:hover {
  background-color: var(--brand-primary);
  color: white;
}

.dropdown-item.danger {
  color: #ef4444;
}

.dropdown-item.danger:hover {
  background-color: #ef4444;
  color: white;
}

.dropdown-divider {
  height: 1px;
  background-color: var(--glass-border);
  margin: 4px 8px;
}

/* Modal Styling */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.create-channel-modal {
  width: 100%;
  max-width: 440px;
  background-color: #313338;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.modal-header {
  padding: 24px;
  text-align: center;
}

.modal-header h2 {
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin-bottom: 8px;
}

.modal-header p {
  color: var(--text-muted);
  font-size: 14px;
}

.modal-content {
  padding: 0 24px 24px;
}

.input-group label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #b5bac1;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.channel-name-input {
  display: flex;
  align-items: center;
  background-color: #1e1f22;
  border-radius: 4px;
  padding: 0 12px;
}

.channel-name-input .prefix {
  color: #b5bac1;
  margin-right: 8px;
  font-size: 20px;
}

.channel-name-input input {
  flex: 1;
  height: 40px;
  background: transparent;
  border: none;
  outline: none;
  color: white;
  font-size: 16px;
}

.modal-footer {
  padding: 16px;
  background-color: #2b2d31;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn {
  background: transparent;
  border: none;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 16px;
}

.create-btn {
  background-color: var(--brand-primary);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.create-btn:hover:not(:disabled) {
  background-color: #7f1d1d;
}

.create-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.voice-pulse-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #22c55e;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
  animation: voice-pulse 2s infinite;
}

@keyframes voice-pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(34, 197, 94, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
  }
}

.channel-item-voice-connected {
  color: #22c55e !important;
}

.channel-item-voice-connected .channel-icon {
  color: #22c55e !important;
}

.voice-status-spinner {
  color: #f59e0b;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Channel Context Menu */
.channel-context-menu {
  position: absolute;
  background: rgba(24, 25, 28, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 6px;
  width: 180px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.context-menu-item {
  padding: 8px 10px;
  font-size: 13px;
  font-weight: 500;
  color: #dbdee1;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.15s, color 0.15s;
}

.context-menu-item:hover {
  background: var(--accent);
  color: #fff;
}

.context-menu-item.danger {
  color: #f23f43;
}

.context-menu-item.danger:hover {
  background: #f23f43;
  color: #fff;
}

.context-menu-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 4px 0;
}

/* Server Banner in Sidebar */
.server-banner-container {
  width: calc(100% - 28px);
  margin: 14px 14px 0 14px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.server-sidebar-banner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.server-banner-container:hover .server-sidebar-banner {
  transform: scale(1.04);
}

/* Voice Channel Participants List in Sidebar */
.voice-channel-group {
  display: flex;
  flex-direction: column;
}

.voice-channel-participants {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px 0 6px 36px;
}

.voice-channel-user {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  color: var(--text-muted, #94a3b8);
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.voice-channel-user:hover {
  background-color: rgba(255, 255, 255, 0.05);
  color: var(--text-primary, #f8fafc);
}

.voice-channel-user.speaking {
  color: #22c55e;
}

.voice-channel-user-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  overflow: visible;
  flex-shrink: 0;
}

.voice-channel-user-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.voice-channel-user.speaking .voice-channel-user-avatar {
  box-shadow: 0 0 0 2px #22c55e, 0 0 8px rgba(34, 197, 94, 0.6);
}

.voice-channel-user.speaking .voice-channel-user-name {
  color: #22c55e;
  font-weight: 600;
}

.voice-channel-user-avatar .speaking-ring {
  position: absolute;
  inset: -3px;
  border-radius: 50%;
  border: 2px solid #22c55e;
  animation: speakPulseSidebar 1.1s ease-in-out infinite;
  pointer-events: none;
}

@keyframes speakPulseSidebar {
  0%, 100% { opacity: 0.5; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.08); }
}

.voice-channel-user-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.voice-channel-user-icons {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.voice-channel-user-icons .user-icon {
  opacity: 0.7;
}

.voice-channel-user-icons .user-icon.muted,
.voice-channel-user-icons .user-icon.deafened {
  color: #ef4444;
  opacity: 1;
}

.voice-channel-user-icons .user-icon.camera,
.voice-channel-user-icons .user-icon.screen {
  color: #3b82f6;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChannelSidebar/ChannelSidebar.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;EACzC,iBAAiB;AACnB;;;AAGA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,oDAAoD;EACpD,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;EACV,2BAA2B;EAC3B,mEAAmE;EACnE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gDAAgD;EAChD,sDAAsD;EACtD,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,oDAAoD;EACpD,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,uFAAuF;EACvF,cAAc;EACd,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,uFAAuF;EACvF,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,aAAa;EAClC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,8BAA8B,sCAAsC,EAAE;AACtE,4BAA4B,oCAAoC,EAAE;AAClE,2BAA2B,mCAAmC,EAAE;AAChE,+BAA+B,uCAAuC,EAAE;;AAExE;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,UAAU;AACZ;;AAEA,wCAAwC,sCAAsC,EAAE;AAChF,sCAAsC,oCAAoC,EAAE;AAC5E,qCAAqC,mCAAmC,EAAE;AAC1E,yCAAyC,uCAAuC,EAAE;;AAElF;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,cAAc,EAAE,iBAAiB;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gFAAgF;EAChF,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;EACA;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sDAAsD;EACtD,oBAAoB;AACtB;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,sBAAsB,EAAE;AAC5C;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,UAAU;AACZ","sourcesContent":[".channel-sidebar {\n  width: var(--sidebar-width);\n  background-color: var(--bg-secondary);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  z-index: 10;\n  box-shadow: var(--shadow-md);\n  border-right: 1px solid var(--glass-border);\n}\n\n.channel-sidebar::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: var(--glass-bg);\n  backdrop-filter: var(--glass-blur);\n  z-index: -1;\n}\n\n.channel-header {\n  height: var(--header-height);\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--glass-border);\n  cursor: pointer;\n  position: relative;\n  transition: all 0.25s ease;\n}\n\n.channel-header.has-banner {\n  height: 95px;\n  align-items: flex-end;\n  padding: 12px 16px;\n  overflow: visible;\n  position: relative;\n}\n\n.server-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n}\n\n.header-banner-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  overflow: hidden;\n  border-radius: inherit;\n}\n\n.header-banner-bg img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  filter: brightness(0.45) saturate(0.85);\n  transition: transform 0.4s ease, filter 0.4s ease;\n}\n\n.channel-header:hover .header-banner-bg img {\n  transform: scale(1.04);\n  filter: brightness(0.55) saturate(1);\n}\n\n.header-banner-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to bottom,\n    rgba(10, 12, 16, 0.3) 0%,\n    rgba(10, 12, 16, 0.7) 60%,\n    var(--bg-secondary, #0c0e14) 100%\n  );\n  z-index: 1;\n}\n\n.header-content {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.has-banner .header-content {\n  background: rgba(12, 14, 20, 0.72);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  padding: 6px 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n  text-shadow: none;\n}\n\n\n.channel-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 0;\n  scrollbar-width: none;\n}\n\n.channel-category {\n  position: relative;\n  margin-bottom: 20px;\n  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;\n}\n\n.channel-category.is-dragging {\n  opacity: 0.35;\n  transform: scale(0.98);\n  filter: grayscale(0.6);\n}\n\n.category-drop-indicator {\n  position: absolute;\n  left: 12px;\n  right: 12px;\n  height: 4px;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n}\n\n.category-drop-indicator.top {\n  top: -4px;\n}\n\n.category-drop-indicator.bottom {\n  bottom: -4px;\n}\n\n.indicator-pill {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #5865f2;\n  box-shadow: 0 0 10px #5865f2, 0 0 4px #fff;\n  margin-left: -4px;\n  flex-shrink: 0;\n}\n\n.indicator-line {\n  flex: 1;\n  height: 2px;\n  background: linear-gradient(90deg, #5865f2, #38bdf8);\n  box-shadow: 0 0 8px rgba(88, 101, 242, 0.8);\n  border-radius: 2px;\n}\n\n.category-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 16px;\n  margin: 0 12px;\n  cursor: pointer;\n  color: var(--text-muted);\n  user-select: none;\n}\n\n.category-header.is-draggable {\n  cursor: grab;\n}\n\n.category-header.is-draggable:active {\n  cursor: grabbing;\n}\n\n.category-drag-handle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  opacity: 0;\n  transform: translateX(-4px);\n  transition: opacity 0.2s ease, transform 0.2s ease, color 0.2s ease;\n  margin-right: -2px;\n  cursor: grab;\n}\n\n.category-header:hover .category-drag-handle {\n  opacity: 0.8;\n  transform: translateX(0);\n}\n\n.category-drag-handle:hover {\n  opacity: 1 !important;\n  color: var(--text-primary);\n}\n\n.category-name {\n  font-size: 11px;\n  font-weight: 900;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n}\n\n.channel-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 18px;\n  margin: 2px 14px;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  color: var(--text-secondary);\n}\n\n.channel-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.channel-name {\n  font-size: 15px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.channel-footer {\n  padding: 8px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background-color: var(--bg-tertiary);\n  border-top: 1px solid var(--glass-border);\n  flex-shrink: 0;\n}\n\n.voice-connection-card {\n  background: rgba(15, 23, 42, 0.75);\n  backdrop-filter: blur(16px);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n}\n\n.voice-connection-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.voice-status-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex: 1;\n}\n\n.voice-status-indicator .dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #22c55e;\n  box-shadow: 0 0 8px #22c55e;\n  flex-shrink: 0;\n}\n\n.voice-status-info {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.voice-status-text {\n  font-size: 11px;\n  font-weight: 700;\n  color: #22c55e;\n  white-space: nowrap;\n}\n\n.voice-channel-pill {\n  font-size: 11px;\n  font-weight: 600;\n  color: #94a3b8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 90px;\n}\n\n.voice-heading-actions {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-shrink: 0;\n}\n\n.voice-action-icon {\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.08) !important;\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  color: #cbd5e1 !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.15s;\n  padding: 0;\n}\n\n.voice-action-icon:hover {\n  background: rgba(255, 255, 255, 0.2) !important;\n  color: #ffffff !important;\n  transform: scale(1.05);\n}\n\n.disconnect-pill.danger {\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  background: rgba(239, 68, 68, 0.18) !important;\n  border: 1px solid rgba(239, 68, 68, 0.35) !important;\n  color: #f87171 !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.15s;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.disconnect-pill.danger:hover {\n  background: #ef4444 !important;\n  color: #ffffff !important;\n  box-shadow: 0 0 10px rgba(239, 68, 68, 0.5);\n  transform: scale(1.05);\n}\n\n.voice-connection-controls {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n.control-pill {\n  flex: 1;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 6px;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: all 0.15s;\n  padding: 0;\n}\n\n.control-pill:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: #f8fafc;\n}\n\n.control-pill.active {\n  background: rgba(239, 68, 68, 0.22);\n  color: #f87171;\n  border-color: rgba(239, 68, 68, 0.45);\n}\n\n.control-pill.krus-pill.active-krus {\n  background: linear-gradient(135deg, rgba(88, 101, 242, 0.35), rgba(139, 92, 246, 0.35));\n  color: #c7d2fe;\n  border-color: rgba(99, 102, 241, 0.6);\n  box-shadow: 0 0 10px rgba(99, 102, 241, 0.4);\n}\n\n.control-pill.krus-pill:hover {\n  background: linear-gradient(135deg, rgba(88, 101, 242, 0.45), rgba(139, 92, 246, 0.45));\n  color: #ffffff;\n}\n\n.voice-connection-actions {\n  display: flex;\n  flex-direction: row; /* Yan yana */\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.voice-connection-actions button {\n  flex: 1;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--glass-border);\n  border-radius: 4px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.voice-connection-actions button:hover {\n  background: var(--bg-modifier-hover);\n  color: var(--text-primary);\n}\n\n.voice-connection-actions button.active {\n  background: var(--brand-primary);\n  color: white;\n  border-color: var(--brand-primary);\n}\n\n.disconnect-pill.danger {\n  width: 36px;\n  height: 36px;\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.disconnect-pill.danger:hover {\n  background: #ef4444;\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n}\n\n.user-panel {\n  height: 64px;\n  background-color: var(--bg-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  border-radius: 20px;\n  border: 1px solid var(--glass-border);\n  box-shadow: var(--shadow-lg);\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n}\n\n.user-avatar {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n}\n\n.user-avatar img {\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  object-fit: cover;\n}\n\n.avatar-inner {\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  background: var(--gradient-brand);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  color: white;\n}\n\n.user-details {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  padding-left: 10px;\n}\n\n.user-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.user-control-pill {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: transparent !important;\n  color: #94a3b8;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n  padding: 0;\n}\n\n.user-control-pill:hover {\n  background: rgba(255, 255, 255, 0.1) !important;\n  color: #f8fafc;\n  transform: translateY(-1px);\n}\n\n.username {\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.user-tag {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-muted);\n  opacity: 0.5;\n}\n\n.dm-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px 0;\n  scrollbar-width: none;\n}\n\n.dm-list::-webkit-scrollbar {\n  display: none;\n}\n\n.dm-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  border-radius: var(--radius-md);\n  margin-bottom: 4px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  border: 1px solid transparent;\n}\n\n.dm-item.active, .dm-item:hover {\n  background-color: var(--bg-modifier-selected);\n  color: var(--text-primary);\n  border-color: var(--glass-border);\n}\n\n.dm-avatar {\n  position: relative;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n}\n\n.dm-avatar img {\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  object-fit: cover;\n  border: 1.5px solid var(--glass-border);\n}\n\n.dm-avatar .avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  background: var(--gradient-brand);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 14px;\n  border: 1.5px solid var(--glass-border);\n}\n\n.dm-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n  text-align: left;\n}\n\n.dm-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n}\n\n.dm-status {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  opacity: 0.6;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: capitalize;\n}\n\n.dm-item.active .dm-status {\n  color: var(--brand-light);\n  opacity: 0.9;\n}\n\n.dm-item .status-dot {\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  width: 12px;\n  height: 12px;\n  border-radius: 4px;\n  border: 2px solid var(--bg-secondary);\n}\n\n.dm-item .status-dot.online { background-color: var(--status-online); }\n.dm-item .status-dot.idle { background-color: var(--status-idle); }\n.dm-item .status-dot.dnd { background-color: var(--status-dnd); }\n.dm-item .status-dot.offline { background-color: var(--status-offline); }\n\n.dm-category {\n  font-size: 11px;\n  font-weight: 900;\n  color: var(--text-muted);\n  padding: 20px 16px 8px;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  opacity: 0.6;\n}\n\n.dm-empty {\n  font-size: 13px;\n  color: var(--text-muted);\n  padding: 24px 16px;\n  text-align: center;\n}\n\n/* User status indicator in the bottom user panel */\n.user-avatar .status-indicator {\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  width: 14px;\n  height: 14px;\n  border-radius: 4px;\n  border: 3px solid var(--bg-tertiary);\n  box-shadow: var(--shadow-sm);\n  z-index: 5;\n}\n\n.user-avatar .status-indicator.online { background-color: var(--status-online); }\n.user-avatar .status-indicator.idle { background-color: var(--status-idle); }\n.user-avatar .status-indicator.dnd { background-color: var(--status-dnd); }\n.user-avatar .status-indicator.offline { background-color: var(--status-offline); }\n\n.dm-search {\n  padding: 16px;\n  margin-bottom: 8px;\n}\n\n.search-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-icon {\n  position: absolute;\n  left: 14px;\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n.search-input-wrapper input {\n  width: 100%;\n  height: 38px;\n  background-color: var(--bg-tertiary);\n  border: 1px solid var(--glass-border);\n  border-radius: 8px;\n  padding: 0 12px 0 40px;\n  color: var(--text-primary);\n  font-size: 14px;\n  font-weight: 600;\n  outline: none;\n  transition: all var(--transition-fast);\n}\n\n.search-input-wrapper input:focus {\n  border-color: var(--brand-primary);\n  background-color: var(--bg-primary);\n  box-shadow: 0 0 0 4px rgba(153, 27, 27, 0.1);\n}\n\n.search-input-wrapper input::placeholder {\n  color: var(--text-muted);\n  opacity: 0.6;\n}\n\n.server-name-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex: 1;\n}\n\n.owner-crown-icon {\n  color: #fbbf24; /* Discord Gold */\n  flex-shrink: 0;\n}\n\n.category-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  margin: 0 4px;\n}\n\n.category-clickable {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  flex: 1;\n}\n\n.category-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.category-action-btn {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s;\n  padding: 0;\n  opacity: 0;\n}\n\n.category-header:hover .category-action-btn {\n  opacity: 1;\n}\n\n.category-action-btn:hover {\n  color: var(--text-primary);\n  background: var(--bg-modifier-hover);\n}\n\n.category-action-btn.danger:hover {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.15);\n}\n\n.empty-category-notice {\n  padding: 8px 16px;\n  font-size: 12px;\n  color: var(--text-muted);\n  font-style: italic;\n}\n\n.empty-category-notice span {\n  font-weight: bold;\n  color: var(--brand-primary);\n}\n\n/* Channel Type Selector in Modal */\n.channel-type-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.channel-type-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 8px;\n  background-color: #2b2d31;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.channel-type-option:hover {\n  background-color: #35373c;\n}\n\n.channel-type-option.active {\n  background-color: rgba(153, 27, 27, 0.2);\n  border-color: var(--brand-primary);\n}\n\n.channel-type-option .type-icon {\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n\n.channel-type-option.active .type-icon {\n  color: var(--brand-primary);\n}\n\n.channel-type-option .type-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.channel-type-option .type-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.channel-type-option .type-desc {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n/* Server Dropdown */\n.server-dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 10px;\n  right: 10px;\n  background-color: #111214;\n  border-radius: 10px;\n  padding: 8px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.75), 0 0 0 1px rgba(255, 255, 255, 0.08);\n  z-index: 9999;\n  border: 1px solid var(--glass-border);\n}\n\n.dropdown-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 90;\n}\n\n.dropdown-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-radius: 4px;\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.dropdown-item:hover {\n  background-color: var(--brand-primary);\n  color: white;\n}\n\n.dropdown-item.danger {\n  color: #ef4444;\n}\n\n.dropdown-item.danger:hover {\n  background-color: #ef4444;\n  color: white;\n}\n\n.dropdown-divider {\n  height: 1px;\n  background-color: var(--glass-border);\n  margin: 4px 8px;\n}\n\n/* Modal Styling */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.create-channel-modal {\n  width: 100%;\n  max-width: 440px;\n  background-color: #313338;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n}\n\n.modal-header {\n  padding: 24px;\n  text-align: center;\n}\n\n.modal-header h2 {\n  font-size: 24px;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 8px;\n}\n\n.modal-header p {\n  color: var(--text-muted);\n  font-size: 14px;\n}\n\n.modal-content {\n  padding: 0 24px 24px;\n}\n\n.input-group label {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  color: #b5bac1;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n\n.channel-name-input {\n  display: flex;\n  align-items: center;\n  background-color: #1e1f22;\n  border-radius: 4px;\n  padding: 0 12px;\n}\n\n.channel-name-input .prefix {\n  color: #b5bac1;\n  margin-right: 8px;\n  font-size: 20px;\n}\n\n.channel-name-input input {\n  flex: 1;\n  height: 40px;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: white;\n  font-size: 16px;\n}\n\n.modal-footer {\n  padding: 16px;\n  background-color: #2b2d31;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.cancel-btn {\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 8px 16px;\n}\n\n.create-btn {\n  background-color: var(--brand-primary);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 24px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.create-btn:hover:not(:disabled) {\n  background-color: #7f1d1d;\n}\n\n.create-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.voice-pulse-indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #22c55e;\n  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);\n  animation: voice-pulse 2s infinite;\n}\n\n@keyframes voice-pulse {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);\n  }\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 6px rgba(34, 197, 94, 0);\n  }\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);\n  }\n}\n\n.channel-item-voice-connected {\n  color: #22c55e !important;\n}\n\n.channel-item-voice-connected .channel-icon {\n  color: #22c55e !important;\n}\n\n.voice-status-spinner {\n  color: #f59e0b;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Channel Context Menu */\n.channel-context-menu {\n  position: absolute;\n  background: rgba(24, 25, 28, 0.95);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  padding: 6px;\n  width: 180px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n}\n\n.context-menu-item {\n  padding: 8px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #dbdee1;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 0.15s, color 0.15s;\n}\n\n.context-menu-item:hover {\n  background: var(--accent);\n  color: #fff;\n}\n\n.context-menu-item.danger {\n  color: #f23f43;\n}\n\n.context-menu-item.danger:hover {\n  background: #f23f43;\n  color: #fff;\n}\n\n.context-menu-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.08);\n  margin: 4px 0;\n}\n\n/* Server Banner in Sidebar */\n.server-banner-container {\n  width: calc(100% - 28px);\n  margin: 14px 14px 0 14px;\n  height: 100px;\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.server-sidebar-banner {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.server-banner-container:hover .server-sidebar-banner {\n  transform: scale(1.04);\n}\n\n/* Voice Channel Participants List in Sidebar */\n.voice-channel-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.voice-channel-participants {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 2px 0 6px 36px;\n}\n\n.voice-channel-user {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--text-muted, #94a3b8);\n  font-size: 13px;\n  font-weight: 500;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.voice-channel-user:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: var(--text-primary, #f8fafc);\n}\n\n.voice-channel-user.speaking {\n  color: #22c55e;\n}\n\n.voice-channel-user-avatar {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  font-size: 10px;\n  font-weight: 700;\n  color: #fff;\n  overflow: visible;\n  flex-shrink: 0;\n}\n\n.voice-channel-user-avatar img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.voice-channel-user.speaking .voice-channel-user-avatar {\n  box-shadow: 0 0 0 2px #22c55e, 0 0 8px rgba(34, 197, 94, 0.6);\n}\n\n.voice-channel-user.speaking .voice-channel-user-name {\n  color: #22c55e;\n  font-weight: 600;\n}\n\n.voice-channel-user-avatar .speaking-ring {\n  position: absolute;\n  inset: -3px;\n  border-radius: 50%;\n  border: 2px solid #22c55e;\n  animation: speakPulseSidebar 1.1s ease-in-out infinite;\n  pointer-events: none;\n}\n\n@keyframes speakPulseSidebar {\n  0%, 100% { opacity: 0.5; transform: scale(1); }\n  50% { opacity: 1; transform: scale(1.08); }\n}\n\n.voice-channel-user-name {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.voice-channel-user-icons {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.voice-channel-user-icons .user-icon {\n  opacity: 0.7;\n}\n\n.voice-channel-user-icons .user-icon.muted,\n.voice-channel-user-icons .user-icon.deafened {\n  color: #ef4444;\n  opacity: 1;\n}\n\n.voice-channel-user-icons .user-icon.camera,\n.voice-channel-user-icons .user-icon.screen {\n  color: #3b82f6;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
